<template>
  <div class="loading-wrap">
    <div class="content-wrap">
      <div class="loading">
        <img src="@/assets/img/logo.png" class="load_men">
        <div class="progress_box">
          <p class="progress" :style="{width:percent + '%'}"></p>
          <span>{{percent}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadImg } from '@/utils'

export default {
  name: 'loading',
  data () {
    return {
      percent: 0,
      loadResource: [
        require('@/assets/img/main/主画面.png'),
        require('@/assets/img/main/烟花1.gif'),
        require('@/assets/img/main/烟花2.gif'),
        require('@/assets/img/main/气球1.png'),
        require('@/assets/img/main/气球2.png'),
        require('@/assets/img/main/气球3.png'),
        require('@/assets/img/main/心.png'),
        require('@/assets/img/广告位1.png'),
        require('@/assets/img/广告位2.png'),
        require('@/assets/img/广告位3.png'),
        require('@/assets/img/领5元微信立减金.png'),
        require('@/assets/img/立即抽奖按钮.png'),
        require('@/assets/img/我的奖品按钮.png')
      ]

    }
  },
  methods: {
    async init () {
      this.$stat({
        event: 'page_loading'
      })
      // 获取活动配置
      await this.$store.dispatch('activity/getAct')
      this.setShare()
      this.$setDocumentTitle(this.activity.title)
      if (!this.activity.is_subscribe) {
        // 二维码页面 判断用户关注
        this.$stat({
          event: 'show_qrcode'
        })
        this.$parent.visibleQrcode = true
        return
      }
      // 预加载资源
      // 根据是否参与过活动预加载对应资源
      // if (this.$store.state.activity.userinfo.face_id) {
      //   this.loadResource.push(require(''))
      // }
      if (this.activity.avatar) {
        this.loadResource.push(this.activity.avatar)
      }
      // 加载人脸识别模型
      // this.loadResource.push(undefined)
      let percent = 0
      for (const resource of this.loadResource) {
        await loadImg(resource)
        percent++
        await this.goTime(Math.floor((percent / this.loadResource.length) * 100))
      }
      this.$router.push('home')
    },
    goTime (percent) {
      return new Promise(resolve => {
        const timer = setInterval(() => {
          if (this.percent < percent && this.percent < 100) {
            this.percent++
          } else {
            clearInterval(timer)
            resolve()
          }
        }, 5)
      })
    }

  },
  created () {
    this.init()
  }
}
</script>

<style lang='scss' scoped>

.loading-wrap{
  overflow: hidden;
  background: url(~@/assets/img/背景2.png) no-repeat;
  background-size: 100%;
  min-height: 100vh;
.loading{
  height: 100vh;
  overflow: hidden;
  position: absolute;
  width: auto;
  min-width: 74%;
  height: auto;
  bottom: 50%;
  right: 50%;
  transform: translate(50%,20%)
}
.load_men{
  width: 216px;
  height: auto;
  display: block;
  margin:auto;
  margin-bottom: 76px;
}
.progress_box{
  width: 476px;
  height: 20px;
  background-color: #FFF4DF;
  border: 2px solid #FFAE00;
  border-radius:10px;
  position: relative;
  margin-right: 68px;
  .progress{
    background:url(~@/assets/img/progress.png) no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: auto;
  }
  span{
    position: absolute;
    left: 486px;
    font-size: 24px;
    color: #000;
    top: -2px;
    line-height: 20px;
    font-weight: bold;
  }
}
}
</style>
